import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { useTheme } from "../context/ThemeContext";

export default function Layout({ children }) {
  const { theme } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1200);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: theme.pageBg,
      display: "flex",
      transition: "background 0.3s ease",
    }}>
      <Sidebar />
      <div style={{
        marginLeft: isMobile ? "0px" : "240px",
        width: isMobile ? "100%" : "calc(100% - 240px)",
        padding: isMobile ? "70px 12px 100px" : "40px",
        boxSizing: "border-box",
        minHeight: "100vh",
        background: theme.pageBg,
        transition: "background 0.3s ease",
      }}>
        {children}
      </div>
    </div>
  );
}
